import cn from 'classnames';
import { useAsyncHandler } from '@@/common/hooks/use-async-handler.hook';
import { NavLink, useLocation, useNavigate } from '@lib/routing-engine';
import { UiButton } from '@@/ui/components/ui-button';
import { IconProps } from '@consta/uikit/Icon';
import { LogoImage } from '@@/common/images';
import styles from './styles.module.sass';
import { ExitIcon } from '@@/common/icons/exit.icons';
import { fetchMixingAnalitycDataFx } from '@widgets/analytics/model';
import {
  setActivesModalOpen,
  setParamsModalOpen,
} from '@/modules/mixing/store/analytical-mixing.store';
import classNames from 'classnames';
import { getLastCachedSearchResultValue } from '@/modules/common/helpers/cache-search-result.helper';
import {
  $notifications,
  fetchNotificationsFx,
  readAllNotificationsFx,
} from '@/widgets/notifications/store/root.store';
import { useStore } from 'effector-react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { OutsideClick } from '@/shared/lib/outside-click';
import { NotificationsModule } from '@/widgets/notifications/components/notifications';

export function SideNav(props: ISideNavProps) {
  const { items, onLogout } = props;

  const { isLoading: isLogouting, handler: onLogoutHandler } = useAsyncHandler({
    handler: onLogout,
  });

  //const navigate = useNavigate();

  const PATH_MATCHER_CONFIG: Record<string, PathMatcherConfig> = {
    '/mixing/recipes-new': {
      path: 'mixing/mixer',
      allowedPaths: ['mixing/mixer', 'mixing/recipe'],
    },
    '/search': {
      path: 'mixing/manual',
      allowedPaths: ['mixing/manual'],
    },
    '/offer/contracts': {
      path: 'offer/contracts',
      allowedPaths: ['offer/contracts'],
    },
    '/mixing/logistics': {
      path: 'mixing/logistics',
      allowedPaths: ['mixing/logistics'],
    },
    '/storage': {
      path: 'storage/create-warehouse',
      allowedPaths: ['storage/create-warehouse'],
    },
  };
  const { pathname } = useLocation();
  const urlParts = useMemo(() => pathname.split('/').filter(Boolean), [pathname]);
  const result = useMemo(
    () => (urlParts.length >= 2 ? `${urlParts[0]}/${urlParts[1]}` : ''),
    [urlParts],
  );

  useEffect(() => {
    fetchNotificationsFx();
  }, []);

  return (
    <div className={styles.root}>
      <NavLink className={styles.logo} to="/">
        <img src={LogoImage} />
      </NavLink>
      <NotificationsModule />

      <nav className={styles.menu}>
        {items.map((itemP) => {
          return itemP.map((item, index) => {
            const config = PATH_MATCHER_CONFIG[item.link];
            const exceptions = config?.allowedPaths.includes(result) ?? false;

            return (
              <NavLink
                key={index}
                className={classNames(
                  styles.link,
                  item.disabled === true && item.title !== 'Склады' && styles.disabled,
                )}
                end
                title={item.title}
                to={item.link}
                // style={{ marginBottom: (index + 1) % 2 === 0 ? '36px' : '0px' }} // ВРЕМЕННО !!!
                style={{ marginBottom: itemP.length === index + 1 ? '36px' : '0px' }}
                onClick={(e) => {
                  if (!item.disabled) {
                    if (item.link === '/mixing') {
                      fetchMixingAnalitycDataFx();
                    } else if (item.link === '/calc') {
                      e.preventDefault();
                      window.location.href = 'https://test-new-mix.liliani.ru/calc';
                    }
                    // else if (item.title === 'Стоимость складов') {
                    //   e.preventDefault();
                    //   fetchMixingAnalitycDataFx();
                    //   //navigate('mixing');
                    //   setActivesModalOpen({ payload: true });
                    // }
                    // else if (item.title === 'Поиск зерна') {
                    //   e.preventDefault();
                    //   navigate('mixing');
                    //   setParamsModalOpen({ payload: true });
                    // }
                  }
                }}
              >
                {(args) => {
                  return (
                    <div
                      className={cn([
                        styles.button,
                        { [styles.button_active]: args.isActive || exceptions },
                      ])}
                    >
                      {item.icon({
                        fill: args.isActive || exceptions ? '#66B28A' : '#DFE6FA',
                        isActive: args.isActive || exceptions,
                      } as IconProps)}
                    </div>
                  );
                }}
              </NavLink>
            );
          });
        })}
      </nav>

      {/*<UiButton*/}
      {/*  className={styles.logout}*/}
      {/*  label="Выйти"*/}
      {/*  view="clear"*/}
      {/*  size="xs"*/}
      {/*  loading={isLogouting}*/}
      {/*  onClick={onLogoutHandler}*/}
      {/*/>*/}
      <UiButton
        className={cn(styles.button, styles.settingsButton)}
        iconLeft={ExitIcon}
        onlyIcon
        loading={isLogouting}
        onClick={onLogoutHandler}
      />
    </div>
  );
}
interface PathMatcherConfig {
  path: string;
  allowedPaths: string[];
}

export interface ISideNavProps {
  items: {
    link: string;
    title: string;
    icon: (props?: IconProps) => React.ReactNode;
    active?: boolean;
    disabled: boolean;
    // badge?: number;
  }[][];

  onLogout: () => void | Promise<void>;
}
